@if (freight()) {
  @for (stop of freight().stopsBasic; track stop.id) {
    <ion-grid class="ion-no-padding">
      <ion-row>
        <ion-col
          size="12"
          [sizeSm]="freight().nextStopId === stop.id && !hideColumns() ? '6' : '12'"
        >
          <div
            class="step"
            [class.step--to-load]="stop.type === EStopType.LOAD"
            [class.step--to-unload]="stop.type === EStopType.UNLOAD"
            [class.step--to-unload_load]="stop.type === EStopType.UNLOAD_LOAD"
            [class.step--active]="isStopActive(stop.id)"
          >
            @if (stop.type === EStopType.LOAD) {
              <ion-icon
                slot="start"
                aria-hidden="true"
                src="../assets/material-symbols/upload_24dp.svg"
              ></ion-icon>
            } @else if (stop.type === EStopType.UNLOAD) {
              <ion-icon
                slot="start"
                aria-hidden="true"
                src="../assets/material-symbols/download_24dp.svg"
              ></ion-icon>
            } @else if (stop.type === EStopType.UNLOAD_LOAD) {
              <ion-icon
                slot="start"
                aria-hidden="true"
                src="../assets/material-symbols/swap_vert_24dp.svg"
              ></ion-icon>
            }
            <div>
              <div class="step-type">
                @if (stop.type === EStopType.LOAD) {
                  {{ 'tasks.load' | translate }}:
                } @else if (stop.type === EStopType.UNLOAD) {
                  {{ 'tasks.unload' | translate }}:
                } @else if (stop.type === EStopType.UNLOAD_LOAD) {
                  {{ 'tasks.unload_load' | translate }}:
                }
                @if (!isStopActive(stop.id)) {
                  <span>
                    ({{ stop.address.countryCode }})
                    {{ stop.address.postalCode }}
                    @if (stop.address.countryCode && stop.address.stateCode) {
                      {{ `states.${stop.address.countryCode}${stop.address.stateCode}` | translate }}
                    }
                  </span>
                }
              </div>
              @if (isStopActive(stop.id)) {
                <lib-freight-carrier-inprogress-card-address
                  [address]="stop.address"
                ></lib-freight-carrier-inprogress-card-address>
              }
            </div>
          </div>
        </ion-col>
        <ion-col [sizeSm]="6">
          @if (isStopActive(stop.id)) {
            <lib-freight-carrier-inprogress-card-schedule
              [since]="stop.since"
              [until]="stop.until"
            ></lib-freight-carrier-inprogress-card-schedule>
          }
        </ion-col>
      </ion-row>
    </ion-grid>
  }
}
